export default function initFAQAccordion(elem) {
  if (!document.querySelector(elem)) {
    return;
  }

  document.addEventListener('DOMContentLoaded', function () {
    //scroll to show selected FAQ
    if (
      document.getElementsByClassName('faq-accordion').length > 0 &&
      document.getElementsByClassName('accordion-section active') != undefined &&
      document.getElementsByClassName('accordion-section active').length > 0
    ) {
      let height = document.getElementsByClassName('accordion-section active')[0]
        .offsetTop;
      window.scrollTo({
        top: height - 120,
        behavior: 'smooth',
      });
    }
  });
}
